import React, { useEffect } from 'react'
import { Ratelimit } from '@upstash/ratelimit'
import { Redis } from '@upstash/redis'
import { DO_RATE_LIMITING, S_DEBUG_MODE } from './api/utils/config'
import {
  isNotNullOrEmptyString,
  toTrimmedStringLowerCase,
} from '../app/utilities/misc'
import { UPSTASH_ENDPOINT, UPSTASH_API_KEY } from './api/utils/config'
import {
  translate,
  SPAIN_ISO_3166_ALPHA_2_CODE,
  FRANCE_ISO_3166_ALPHA_2_CODE,
  SOUTH_KOREA_ISO_3166_ALPHA_2_CODE,
  UNITED_STATES_ISO_3166_ALPHA_2_CODE,
} from '../app/utilities/language'
import {
  DEBUG_MODE,
  OG_SITE_URL,
  OG_SITE_NAME,
  CONTACT_EMAIL,
  TITLE_TAG_HOME,
  OG_PAGE_URL_HOME,
  JSON_LD_TYPE_HOME,
  JSON_LD_SITE_NAME,
  META_KEYWORDS_HOME,
  OG_SITE_URL_FRENCH,
  OG_SITE_URL_KOREAN,
  OG_SITE_URL_SPANISH,
  OG_SITE_NAME_FRENCH,
  OG_SITE_NAME_KOREAN,
  OG_SITE_NAME_SPANISH,
  META_DESCRIPTION_HOME,
  TITLE_TAG_HOME_FRENCH,
  TITLE_TAG_HOME_KOREAN,
  JSON_LD_TITLE_GENERIC,
  OPEN_GRAPH_PAGE_IMAGE,
  HOME_PAGE_DISPLAY_NAME,
  TITLE_TAG_HOME_SPANISH,
  OG_PAGE_URL_HOME_FRENCH,
  OG_PAGE_URL_HOME_KOREAN,
  JSON_LD_URL_HOME_FRENCH,
  JSON_LD_URL_HOME_KOREAN,
  JSON_LD_URL_HOME_SPANISH,
  JSON_LD_URL_HOME_ENGLISH,
  JSON_LD_SITE_NAME_FRENCH,
  JSON_LD_SITE_NAME_KOREAN,
  OG_PAGE_URL_HOME_SPANISH,
  JSON_LD_SITE_NAME_SPANISH,
  CANONICAL_URL_HOME_FRENCH,
  CANONICAL_URL_HOME_KOREAN,
  META_KEYWORDS_HOME_FRENCH,
  META_KEYWORDS_HOME_KOREAN,
  CANONICAL_URL_HOME_SPANISH,
  CANONICAL_URL_HOME_ENGLISH,
  META_KEYWORDS_HOME_SPANISH,
  JSON_LD_DESCRIPTION_GENERIC,
  JSON_LD_TITLE_GENERIC_FRENCH,
  JSON_LD_TITLE_GENERIC_KOREAN,
  META_DESCRIPTION_HOME_FRENCH,
  META_DESCRIPTION_HOME_KOREAN,
  OPEN_GRAPH_PAGE_IMAGE_FRENCH,
  OPEN_GRAPH_PAGE_IMAGE_KOREAN,
  META_DESCRIPTION_HOME_SPANISH,
  JSON_LD_TITLE_GENERIC_SPANISH,
  OPEN_GRAPH_PAGE_IMAGE_SPANISH,
  JSON_LD_DESCRIPTION_GENERIC_FRENCH,
  JSON_LD_DESCRIPTION_GENERIC_KOREAN,
  JSON_LD_DESCRIPTION_GENERIC_SPANISH,
  JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT,
  JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_FRENCH,
  JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_KOREAN,
  JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_SPANISH,
} from '../app/utilities/config'
import useWindowDimensions from '../app/components/hooks/useWindowDimensions'
import {
  HOME_TITLE_MARKUP_STR,
  HOME_TITLE_MARKUP_STR_ES,
  HOME_TITLE_MARKUP_STR_FR,
  HOME_TITLE_MARKUP_STR_KO,
} from '../app/static-data/index-data'
import dynamic from 'next/dynamic'

const Home: React.ComponentType<any> = dynamic(
  () => import('../app/components/pages/Home/Home'),
  {
    ssr: true,
  }
)

function HomePage(props: any) {
  const { width, height } =
    typeof window !== 'undefined'
      ? useWindowDimensions()
      : { width: 0, height: 0 }

  useEffect(() => {
    try {
      props?.broadcastDimensions(height, width)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
    }
  }, [width, height])

  return (
    <Home
      isBot={props?.isBot}
      width={props?.width}
      height={props?.height}
      navigateRoute={props?.navigateRoute}
      avifCompatible={props?.avifCompatible}
      selectedLanguage={props?.selectedLanguage}
      broadcastDimensions={props?.broadcastDimensions}
    />
  )
}

const cache: Map<any, any> = new Map()
const redis: Redis = new Redis({
  url: UPSTASH_ENDPOINT,
  token: UPSTASH_API_KEY,
})
const ratelimit: any = new Ratelimit({
  redis: redis,
  limiter: Ratelimit.slidingWindow(9, '3 s'),
  ephemeralCache: cache,
})

export async function getServerSideProps(context: any) {
  let initialCountryCode: any = ''
  const initialLocale: any = context?.locale
  const initialLang: string =
    isNotNullOrEmptyString(initialLocale) &&
    initialLocale?.toString().indexOf('-') > 1
      ? initialLocale.split('-')[0]
      : initialLocale
  try {
    if (isNotNullOrEmptyString(context?.req?.headers['x-vercel-ip-country']))
      initialCountryCode = context?.req?.headers['x-vercel-ip-country']
        ?.toString()
        .trim()
    else
      initialCountryCode =
        initialLang == 'ko'
          ? SOUTH_KOREA_ISO_3166_ALPHA_2_CODE
          : initialLang == 'fr'
          ? FRANCE_ISO_3166_ALPHA_2_CODE
          : initialLang == 'es'
          ? SPAIN_ISO_3166_ALPHA_2_CODE
          : UNITED_STATES_ISO_3166_ALPHA_2_CODE
  } catch (ecs: any) {
    if (S_DEBUG_MODE) console.log(ecs)
  }
  try {
    try {
      context?.res.setHeader(
        'Cache-Control',
        'max-age=120, s-maxage=120, stale-while-revalidate=120'
      )
      context?.res.setHeader('X-Frame-Options', 'SAMEORIGIN')
    } catch (er) {
      if (S_DEBUG_MODE) console.log(er)
    }
    let rateLimited: boolean = false
    let isBot: boolean = false
    try {
      const BOTS_USER_AGENT_LIST = (await import('../app/utilities/bots'))
        .BOTS_USER_AGENT_LIST
      let userAgentLowerCase = context?.req?.headers['user-agent']
        ?.toString()
        .trim()
        .toLowerCase()
      if (isNotNullOrEmptyString(userAgentLowerCase))
        for (let i = 0; i < BOTS_USER_AGENT_LIST?.length; i++) {
          if (
            userAgentLowerCase.indexOf(
              toTrimmedStringLowerCase(BOTS_USER_AGENT_LIST[i]?.userAgent)
            ) > -1
          ) {
            isBot = true
            break
          }
        }
    } catch (erra) {
      if (S_DEBUG_MODE) console.log(erra)
    }
    try {
      if (DO_RATE_LIMITING && !isBot) {
        try {
          const ip = context?.req?.ip ?? '127.0.0.1'
          const { success } = await ratelimit.limit(ip)
          rateLimited = !success
        } catch (er: any) {
          if (S_DEBUG_MODE) console.log(er)
        }
        if (rateLimited) isBot = true
      }
    } catch (erra) {
      if (S_DEBUG_MODE) console.log(erra)
    }
    return {
      props: {
        initialLocale: initialLocale,
        initialLang: initialLang,
        initialCountryCode: initialCountryCode,
        canonicalUrl: translate(
          CANONICAL_URL_HOME_ENGLISH,
          CANONICAL_URL_HOME_SPANISH,
          CANONICAL_URL_HOME_FRENCH,
          CANONICAL_URL_HOME_KOREAN,
          initialLang
        ),
        jsonLdSiteName: translate(
          JSON_LD_SITE_NAME,
          JSON_LD_SITE_NAME_SPANISH,
          JSON_LD_SITE_NAME_FRENCH,
          JSON_LD_SITE_NAME_KOREAN,
          initialLang
        ),
        ogPageUrl: translate(
          OG_PAGE_URL_HOME,
          OG_PAGE_URL_HOME_SPANISH,
          OG_PAGE_URL_HOME_FRENCH,
          OG_PAGE_URL_HOME_KOREAN,
          initialLang
        ),
        ogSiteUrl: translate(
          OG_SITE_URL,
          OG_SITE_URL_SPANISH,
          OG_SITE_URL_FRENCH,
          OG_SITE_URL_KOREAN,
          initialLang
        ),
        ogSiteName: translate(
          OG_SITE_NAME,
          OG_SITE_NAME_SPANISH,
          OG_SITE_NAME_FRENCH,
          OG_SITE_NAME_KOREAN,
          initialLang
        ),
        jsonLdType: JSON_LD_TYPE_HOME,
        jsonLdOrganizationDescription: translate(
          JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT,
          JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_SPANISH,
          JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_FRENCH,
          JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_KOREAN,
          initialLang
        ),
        jsonLdHomeUrl: translate(
          JSON_LD_URL_HOME_ENGLISH,
          JSON_LD_URL_HOME_SPANISH,
          JSON_LD_URL_HOME_FRENCH,
          JSON_LD_URL_HOME_KOREAN,
          initialLang
        ),
        jsonLdOrganizationContactEmail: CONTACT_EMAIL,
        jsonLdArticleHeadline: '',
        jsonLdArticleImage1200x1200: '',
        jsonLdArticleDatePublished: '',
        jsonLdArticleDateCreated: '',
        jsonLdArticleUrl: '',
        jsonLdArticleInLanguage: initialLang,
        jsonLdArticleKeywords: '',
        jsonLdTitle: translate(
          JSON_LD_TITLE_GENERIC,
          JSON_LD_TITLE_GENERIC_SPANISH,
          JSON_LD_TITLE_GENERIC_FRENCH,
          JSON_LD_TITLE_GENERIC_KOREAN,
          initialLang
        ),
        jsonLdDescription: translate(
          JSON_LD_DESCRIPTION_GENERIC,
          JSON_LD_DESCRIPTION_GENERIC_SPANISH,
          JSON_LD_DESCRIPTION_GENERIC_FRENCH,
          JSON_LD_DESCRIPTION_GENERIC_KOREAN,
          initialLang
        ),
        ogPageImage: translate(
          OPEN_GRAPH_PAGE_IMAGE,
          OPEN_GRAPH_PAGE_IMAGE_SPANISH,
          OPEN_GRAPH_PAGE_IMAGE_FRENCH,
          OPEN_GRAPH_PAGE_IMAGE_KOREAN,
          initialLang
        ),
        titleTag: translate(
          TITLE_TAG_HOME,
          TITLE_TAG_HOME_SPANISH,
          TITLE_TAG_HOME_FRENCH,
          TITLE_TAG_HOME_KOREAN,
          initialLang
        ),
        metaDescription: translate(
          META_DESCRIPTION_HOME,
          META_DESCRIPTION_HOME_SPANISH,
          META_DESCRIPTION_HOME_FRENCH,
          META_DESCRIPTION_HOME_KOREAN,
          initialLang
        ),
        metaKeywords: translate(
          META_KEYWORDS_HOME,
          META_KEYWORDS_HOME_SPANISH,
          META_KEYWORDS_HOME_FRENCH,
          META_KEYWORDS_HOME_KOREAN,
          initialLang
        ),
        jsonLdBlogTitle: translate(
          HOME_TITLE_MARKUP_STR,
          HOME_TITLE_MARKUP_STR_ES,
          HOME_TITLE_MARKUP_STR_FR,
          HOME_TITLE_MARKUP_STR_KO,
          initialLang
        ),
        rl: rateLimited,
        ib: isBot,
      },
    }
  } catch (e) {
    if (S_DEBUG_MODE) console.log(e)
    return {
      props: {
        initialLocale: initialLocale,
        initialLang: initialLang,
        initialCountryCode: initialCountryCode,
        canonicalUrl: translate(
          CANONICAL_URL_HOME_ENGLISH,
          CANONICAL_URL_HOME_SPANISH,
          CANONICAL_URL_HOME_FRENCH,
          CANONICAL_URL_HOME_KOREAN,
          initialLang
        ),
        jsonLdSiteName: translate(
          JSON_LD_SITE_NAME,
          JSON_LD_SITE_NAME_SPANISH,
          JSON_LD_SITE_NAME_FRENCH,
          JSON_LD_SITE_NAME_KOREAN,
          initialLang
        ),
        ogPageUrl: translate(
          OG_PAGE_URL_HOME,
          OG_PAGE_URL_HOME_SPANISH,
          OG_PAGE_URL_HOME_FRENCH,
          OG_PAGE_URL_HOME_KOREAN,
          initialLang
        ),
        ogSiteUrl: translate(
          OG_SITE_URL,
          OG_SITE_URL_SPANISH,
          OG_SITE_URL_FRENCH,
          OG_SITE_URL_KOREAN,
          initialLang
        ),
        ogSiteName: translate(
          OG_SITE_NAME,
          OG_SITE_NAME_SPANISH,
          OG_SITE_NAME_FRENCH,
          OG_SITE_NAME_KOREAN,
          initialLang
        ),
        jsonLdType: JSON_LD_TYPE_HOME,
        jsonLdOrganizationDescription: translate(
          JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT,
          JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_SPANISH,
          JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_FRENCH,
          JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_KOREAN,
          initialLang
        ),
        jsonLdHomeUrl: translate(
          JSON_LD_URL_HOME_ENGLISH,
          JSON_LD_URL_HOME_SPANISH,
          JSON_LD_URL_HOME_FRENCH,
          JSON_LD_URL_HOME_KOREAN,
          initialLang
        ),
        jsonLdOrganizationContactEmail: CONTACT_EMAIL,
        jsonLdArticleHeadline: '',
        jsonLdArticleImage1200x1200: '',
        jsonLdArticleDatePublished: '',
        jsonLdArticleDateCreated: '',
        jsonLdArticleUrl: '',
        jsonLdArticleInLanguage: initialLang,
        jsonLdArticleKeywords: '',
        jsonLdTitle: translate(
          JSON_LD_TITLE_GENERIC,
          JSON_LD_TITLE_GENERIC_SPANISH,
          JSON_LD_TITLE_GENERIC_FRENCH,
          JSON_LD_TITLE_GENERIC_KOREAN,
          initialLang
        ),
        jsonLdDescription: translate(
          JSON_LD_DESCRIPTION_GENERIC,
          JSON_LD_DESCRIPTION_GENERIC_SPANISH,
          JSON_LD_DESCRIPTION_GENERIC_FRENCH,
          JSON_LD_DESCRIPTION_GENERIC_KOREAN,
          initialLang
        ),
        ogPageImage: translate(
          OPEN_GRAPH_PAGE_IMAGE,
          OPEN_GRAPH_PAGE_IMAGE_SPANISH,
          OPEN_GRAPH_PAGE_IMAGE_FRENCH,
          OPEN_GRAPH_PAGE_IMAGE_KOREAN,
          initialLang
        ),
        titleTag: translate(
          TITLE_TAG_HOME,
          TITLE_TAG_HOME_SPANISH,
          TITLE_TAG_HOME_FRENCH,
          TITLE_TAG_HOME_KOREAN,
          initialLang
        ),
        metaDescription: translate(
          META_DESCRIPTION_HOME,
          META_DESCRIPTION_HOME_SPANISH,
          META_DESCRIPTION_HOME_FRENCH,
          META_DESCRIPTION_HOME_KOREAN,
          initialLang
        ),
        metaKeywords: translate(
          META_KEYWORDS_HOME,
          META_KEYWORDS_HOME_SPANISH,
          META_KEYWORDS_HOME_FRENCH,
          META_KEYWORDS_HOME_KOREAN,
          initialLang
        ),
        jsonLdBlogTitle: translate(
          HOME_TITLE_MARKUP_STR,
          HOME_TITLE_MARKUP_STR_ES,
          HOME_TITLE_MARKUP_STR_FR,
          HOME_TITLE_MARKUP_STR_KO,
          initialLang
        ),
        rl: false,
        ib: false,
      },
    }
  }
}

HomePage.displayName = HOME_PAGE_DISPLAY_NAME

export default HomePage
